export const Three = () => {
  return (
    <svg
      width={32}
      height={40}
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.987 37.02l-4.664-10.368-.75-1.25 9.87-3.83 4.913 10.785-5.663.874-3.706 3.79z"
        fill="#127FBE"
        stroke="#000"
        strokeWidth={0.0832861}
      />
      <path
        d="M4.091 33.863l3.267-10.89.252-1.435 9.967 3.569-3.35 11.368-4.853-3.048-5.283.436z"
        fill="#127FBE"
        stroke="#000"
        strokeWidth={0.0832861}
      />
      <circle cx={16.5736} cy={13.2425} r={13.2425} fill="#905923" />
      <path
        d="M16.24 26.485V0C11.703 0 2.822 3.14 3.355 13.7c.533 10.561 8.653 12.785 12.887 12.785z"
        fill="#7B4C1E"
      />
      <path
        d="M7.745 10.452c-.985 2.804-1.066 9.112 6.496 11.91M25.402 16.24c.986-2.804 1.066-9.111-6.496-11.91"
        stroke="#674019"
        strokeWidth={0.666289}
        strokeLinecap="round"
      />
      <path
        d="M13.01 10.767c.04-1.079.393-1.911 1.06-2.496.665-.585 1.567-.877 2.707-.877.757 0 1.402.13 1.937.393.544.262.953.62 1.225 1.074.282.454.424.963.424 1.528 0 .666-.167 1.21-.5 1.634-.332.413-.72.696-1.165.847v.06c.575.192 1.03.51 1.362.954.333.443.5 1.013.5 1.71 0 .624-.147 1.18-.44 1.663-.282.474-.7.848-1.255 1.12-.545.272-1.195.408-1.952.408-1.21 0-2.178-.297-2.904-.892-.716-.595-1.095-1.493-1.135-2.693h2.511c.01.444.136.797.379 1.059.242.252.595.378 1.059.378.393 0 .695-.11.907-.333.222-.232.333-.534.333-.907 0-.485-.156-.833-.469-1.044-.303-.222-.792-.333-1.467-.333h-.484v-2.103h.484c.514 0 .928-.086 1.24-.257.323-.182.484-.5.484-.953 0-.363-.1-.646-.302-.848-.202-.201-.48-.302-.832-.302-.384 0-.671.116-.863.348-.181.232-.287.52-.317.862H13.01z"
        fill="#674019"
      />
    </svg>
  );
};
